import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class MomentLocaleInitService {
  init() {
    moment.locale(window.navigator.language);
  }
}
